import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import en from '../locales/en-US/translations.json';
import fr from '../locales/fr-FR/translations.json';
import de from '../locales/de-DE/translations.json';
import nl from '../locales/nl-NL/translations.json';
import it from '../locales/it-IT/translations.json';
import ja from '../locales/ja-JP/translations.json';
import zh from '../locales/zh-CN/translations.json';
export const instance = i18n.createInstance();
instance
    .init({
    lng: 'en',
    fallbackLng: 'en',
    load: 'currentOnly',
    defaultNS: 'translations',
    react: { useSuspense: false },
    resources: {
        en: { translations: en },
        fr: { translations: fr },
        de: { translations: de },
        nl: { translations: nl },
        it: { translations: it },
        ja: { translations: ja },
        zh: { translations: zh }
    }
});
export const useDoubleTTranslation = (locale) => {
    const { t } = useTranslation(undefined, { i18n: instance });
    const tt = (key, options) => {
        return t(key, Object.assign(Object.assign({}, options), { lng: locale || 'en' }));
    };
    return { i18n, tt };
};
//# sourceMappingURL=i18n.js.map